export default __webpack_public_path__ + "static/media/calendar_book.c7bb3093.svg";